import React from 'react';
import PropTypes from 'prop-types';
import { Component } from 'common/helpers';

import './spacer.less';

export default class Spacer extends Component {
  getModifiers() {
    return [this.props.height ? 'custom' : this.props.size];
  }

  getExtraClasses() {
    return [this.props.desktop ? 'desktop-only' : null];
  }

  getStyle() {
    if (!this.props.height) return undefined;
    const height =
      typeof this.props.height === 'number'
        ? `${this.props.height}px`
        : this.props.height;
    return { '--spacer-height': height };
  }

  render() {
    return <div {...this.getAttrs()} style={this.getStyle()} />;
  }
}

Spacer.propTypes = {
  desktop: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Spacer.defaultProps = {
  desktop: false,
};
